import HashMap from 'hashmap';
import common from './common.js';
import util from '../../../commons/util.js';
let subscribeObjMap = new HashMap();
let channelInfoMap = new HashMap();

/**
 * @func  getDestination
 * @desc  根据通道请求类型获取相应的目的地址参数
 * @param {object} channelId  通道id
 * @param {String} routingKeys  路由键 （可选参数）
 * @return {object} destination 目的地址
 */
function getDestination(channelId, routingKeys) {
    let channelInfo = channelInfoMap.get(channelId);
    let destination = [];
    if (!util.isEmpty(channelId)) {
        // 客户端订阅、发送目的地类型: 0:/queue ; 1:/exchange ; 2:/amq/queue ; 3:/topic ; 4:/temp-queue

        // 1: /exchange/exchangename/[routing_key] :通过转发器订阅/发布消息，转发器需要手动创建
        // 3:  /topic/routing_key：通过amq.topic转发器订阅/发布消息，订阅时默认创建一个临时队列，通过routing_key与topic进行绑定
        if (channelInfo.modeType === common.modeType.EXCHANGE || channelInfo.modeType === common.modeType.TOPIC) {
            if (!util.isEmpty(routingKeys)) {
                let routingKey = routingKeys.split(',');
                for (let i = 0; i < routingKey.length; i++) {
                    if (channelInfo.modeType === common.modeType.EXCHANGE) {
                        destination[i] = common.modeType.EXCHANGE_VALUE + channelInfo.channelName + '/' + routingKey[i];
                    } else {
                        destination[i] = common.modeType.TOPIC_VALUE + routingKey[i];
                    }
                }
            } else {
                destination[0] = common.modeType.EXCHANGE_VALUE + channelInfo.channelName;
            }
        }
        // 0:  /queue/queuename :使用默认转发器订阅/发布消息，默认由stomp自动创建一个持久化队列
        if (channelInfo.modeType === common.modeType.WORK_QUEUE) {
            destination[0] = common.modeType.WORK_QUEUE_VALUE + channelInfo.channelName;
        }
        // 2:  /amq/queue/queuename：与/queue/queuename的区别在于队列不由stomp自动进行创建，队列不存在失败
        if (channelInfo.modeType === common.modeType.AMQ_QUEUE) {
            destination[0] = common.modeType.AMQ_QUEUE_VALUE + channelInfo.channelName;
        }
        // 4:  /temp-queue/xxx：创建一个临时队列(只能在headers中的属性reply-to中使用)，可用于发送消息后通过临时队列接收回复消息
        if (channelInfo.modeType === common.modeType.TEMP_QUEUE) {
            destination[0] = common.modeType.TEMP_QUEUE_VALUE + channelInfo.channelName;
        }
    }
    return destination;
}
export default {
    /**
     * @func  addChannelInfo
     * @desc  添加通道信息
     * @param {object} channelInfo 需要转换的对象
     * @return {boolean} 是否成功
     */
    addChannelInfo(channelInfo) {
        if (!util.isEmpty(channelInfo)) {
            channelInfoMap.set(channelInfo.channelId, channelInfo);
            return true;
        }
        return false;
    },
    /**
     * @func  updateChannelInfo
     * @desc  修改通道信息
     * @param {object} channelInfo 需要转换的对象
     * @return {boolean} 是否成功
     */
    updateChannelInfo(channelInfo) {
        if (!util.isEmpty(channelInfo)) {
            channelInfoMap.set(channelInfo.channelId, channelInfo);
            return true;
        }
        return false;
    },
    /**
     * @func  removeChannelInfoById
     * @desc  根据通道Id删除通道信息
     * @param {string} channelId  通道id
     * @return {boolean} 是否成功
     */
    removeChannelInfoById(channelId) {
        if (channelInfoMap.has(channelId)) {
            channelInfoMap.remove(channelId);
            return true;
        }
        return false;
    },
    /**
     * @func  getChannelInfoById
     * @desc  根据通道Id查询通道信息
     * @param {string} channelId  通道id
     * @return {object}  channelInfo 通道对象
     */
    getChannelInfoById(channelId) {
        return channelInfoMap.get(channelId);
    },
    /**
     * @func  getMqIdByChannelId
     * @desc  根据通道Id查询该通道所属的MQId
     * @param {string} channelId  通道id
     * @return {String}  mqId 所属MQId
     */
    getMqIdByChannelId(channelId) {
        let mqId = null;
        if (!util.isEmpty(channelId) && channelInfoMap.has(channelId)) {
            let channelInfo = channelInfoMap.get(channelId);
            if (!util.isEmpty(channelInfo)) {
                mqId = channelInfo.mqId;
            }
        }
        return mqId;
    },
    /**
     * @func  isExistChannelInfo
     * @desc  查询通道对象信息是否存在
     * @param {string} channelId  通道id
     * @return {boolean} 是否存在
     */
    isExistChannelInfo(channelId) {
        return channelInfoMap.has(channelId);
    },

    /**
     * @func  cleanChannelInfo
     * @desc  清空通道信息
     * @return {object} null
     */
    cleanChannelInfo() {
        channelInfoMap.clear();
    },
    subscribeObjMapInfo() {
        subscribeObjMap.clear();
    },
    /**
     * @func  send
     * @desc  向MQ发送消息
     * @param {object} mqInstance Mq连接实例
     * @param {string} channelId 通道id
     * @param {String} routingKeys 路由键 （可选参数）
     * @param {string} msg 消息信息
     * @return {object} returnInfo
     */
    send(mqInstance, channelId, routingKeys, msg) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_FAIL'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        // 判断通道是否存在
        if (channelInfoMap.has(channelId)) {
            // 获取目的地址
            let destination = getDestination(channelId, routingKeys);
            if (destination && Array.isArray(destination) && destination.length > 0) {
                for (let i = 0; i < destination.length; i++) {
                    mqInstance.send(destination[i], {}, JSON.stringify(msg));
                }
                returnInfo.description = window.vue.$t('returnInfo.REQUEST_SUCCESS');
                returnInfo.ret = window.vue.$t('returnInfo.SUCCESS');
            }
        }
        return returnInfo;
    },
    /**
     * @func  subscribe
     * @desc  订阅MQ消息
     * @param {object} mqInstance Mq连接实例
     * @param {string} channelId 通道id
     * @param {string} routingKeys 路由键 （可选参数）
     * @param {string} reciveCallback 回调函数
     * @param {string} subscribeId 订阅id
     * @return {function} reciveCallback 订阅成功回调函数
     */
    subscribe(mqInstance, channelId, routingKeys, reciveCallback, subscribeId) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_FAIL'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (mqInstance) {
            if (subscribeObjMap.has(subscribeId + routingKeys)) {
                this.unsubscribe(subscribeId, routingKeys);
            }

            // 获取目的地址
            let destination = getDestination(channelId, routingKeys);
            if (destination && Array.isArray(destination) && destination.length > 0) {
                let subscribeObjArr = [];
                for (let i = 0; i < destination.length; i++) {
                    // 每次订阅时，需新new headers,否则取消订阅时，使用的headers对象是同一个
                    let headers = { id: subscribeId + routingKeys + '_' + i };
                    subscribeObjArr[i] = mqInstance.subscribe(destination[i], reciveCallback, headers);
                }
                returnInfo.description = window.vue.$t('returnInfo.REQUEST_SUCCESS');
                returnInfo.ret = window.vue.$t('returnInfo.SUCCESS');
                subscribeObjMap.set(subscribeId + routingKeys, subscribeObjArr);
            }
        }
        return returnInfo;
    },
    /**
     * @func  unsubscribe
     * @desc  取消订阅
     * @param {string} subscribeId 订阅对象id
     * @return {Object} returnInfo
     */
    unsubscribe(subscribeId, routingKeys) {
        let returnInfo = {
            description: window.vue.$t('returnInfo.REQUEST_FAIL'),
            ret: window.vue.$t('returnInfo.FAIL')
        };
        if (subscribeObjMap.has(subscribeId + routingKeys)) {
            let subscribeObj = subscribeObjMap.get(subscribeId + routingKeys);
            if (subscribeObj && Array.isArray(subscribeObj)) {
                for (let i = 0; i < subscribeObj.length; i++) {
                    subscribeObj[i].unsubscribe();
                }
            } else {
                return returnInfo;
            }
            subscribeObjMap.remove(subscribeId + routingKeys);
            returnInfo.description = window.vue.$t('returnInfo.REQUEST_SUCCESS');
            returnInfo.ret = window.vue.$t('returnInfo.SUCCESS');
        }
        return returnInfo;
    },
    /**
     * @func  isExistSubscribeObj
     * @desc  查询订阅对象信息是否存在
     * @param {string} subscribeId 订阅对象id
     * @return {boolean} 是否存在
     */
    isExistSubscribeObj(subscribeId) {
        return subscribeObjMap.has(subscribeId);
    },
    /**
     * @func  getSubscribeObj
     * @desc  查询订阅对象信息是否存在
     * @param {string} subscribeId 订阅对象id
     * @return {Object} 订阅对象
     */
    getSubscribeObj(subscribeId) {
        return subscribeObjMap.get(subscribeId);
    }
};
